// API Configuration
// In Docker, nginx proxies /api requests to the backend service
// In development, we use localhost:8000 directly

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const getApiUrl = (path: string): string => {
  // If using proxy (/api), path should not start with /
  if (API_BASE_URL.startsWith('/api')) {
    return `${API_BASE_URL}${path}`;
  }
  // Otherwise, full URL with path
  return `${API_BASE_URL}${path}`;
};

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    CLASSIFY_QUERY: '/classify/query',
    AUTH: '/auth',
    DOCUMENTS: '/documents',
    WILLS: '/wills',
    BILL_OF_SALE: '/bill-of-sale',
    EXPORT: '/export',
  },
};
